// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3tnNQ","resendInfoText":"OnGoingPaymentBox_resendInfoText__2zW9V"};